export default __webpack_public_path__ + "static/qiita_org-12fdcc02ed52eeb063689a1d18c94f1b.png";